import React from 'react';
interface MetaphorPreviewProps {
  image: string;
}
export function MetaphorPreview({
  image
}: MetaphorPreviewProps) {
  return <div className="group relative bg-slate-50 rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2" data-id="element-12">
      <div className="h-[500px] overflow-hidden" data-id="element-13">
        <img src={image} alt="Metáfora terapéutica" className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" data-id="element-14" />
      </div>
    </div>;
}